import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import {Link} from 'react-router-dom';
import PotteryGardenFlashImages from "./PotteryGardenFlashImages";

class PotteryGarden extends Component {
  constructor(props) {
    super(props);
    this.state = {
      potterygardenpage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "potterygardenNew",
    }).then((entries) => {
      this.setState({ potterygardenpage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(potterygardenDescription) {
    return {
      __html: marked(potterygardenDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.potterygardenpage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.potterygardenpage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.potterygardenTitle}</h1>
                    <h2 className="lead">{item.fields.potterygardenShortDetails}</h2>
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.potterygardenImg.fields.file.url}
                          alt="sam bridge pottery garden supplies"
                        />
                        
                      </div>
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.potterygardenDescription
                        )}>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

          <div className="pt-4">
            <Link to="/pottery-garden-gallery"><PotteryGardenFlashImages/></Link>  
          </div>

      {/* <div className="pt-4">
      <Link to="/locally-grown-gallery"><button className="btn btn-primary">View Gallery</button></Link>
      </div> */}
      </div>
      
      </>
    );
  }
}

export default PotteryGarden;
